"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.slider = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var slider = {
  sliderHeight: '10px',
  sliderBorder: 'none',
  sliderBorderRadius: _size["default"].borderRadiusMedium,
  sliderTrackBorderRadius: _size["default"].borderRadiusMedium,
  sliderTrackBackgroundColor: _color["default"].cloudyBlue300,
  sliderActiveTrackBackgroundColor: _color["default"].pickledBluewood,
  sliderActiveTrackBackgroundColorDisabled: _color["default"].steel700,
  sliderKnobSize: _size["default"].default2x,
  sliderKnobColor: _color["default"].white,
  sliderKnobColorDisabled: _color["default"].white,
  sliderKnobBorderColor: _color["default"].pickledBluewood,
  sliderKnobBorderColorDisabled: _color["default"].steel700,
  sliderKnobBorderRadius: '50%',
  sliderKnobShadow: 'none'
};
exports.slider = slider;
var _default = slider;
exports["default"] = _default;